import { memo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import findIndex from 'lodash/findIndex';

import { roundedContainer } from 'components/Container/styles.module.scss';
import {
  stepperLabel,
  stepperCount,
  stepperListItem,
  stepperListItemComplete,
  stepperList,
  stepperLabelComplete,
  stepperTick,
  srOnly
} from './styles.module.scss';

const navLinks = [
  { label: 'Account details', count: 1, link: '/' },
  { label: 'UK mobile', count: 2, link: '/mobile-number' },
  { label: 'Number sent', count: 3, link: '/confirmation' }
];

const StepsSidebar = memo(
  withRouter(({ location: { pathname } }) => {
    const currentStepIndex = findIndex(navLinks, ({ link }) => link === pathname);
    return (
      <aside role="region" className={roundedContainer}>
        <ul className={stepperList}>
          {navLinks.map(({ _, label, count }, index) => {
            const isActive = currentStepIndex === index;
            const isComplete = currentStepIndex > index;
            const lastItem = isActive && count === 3;
            return (
              <li
                className={classNames(stepperListItem, {
                  [stepperListItemComplete]: isActive || isComplete
                })}
                key={count}
              >
                <span
                  className={classNames(stepperCount, { [stepperTick]: isComplete || lastItem })}
                >
                  <span className={classNames({ [srOnly]: isComplete || lastItem })}>{count}</span>
                </span>
                <span
                  className={classNames(stepperLabel, {
                    [stepperLabelComplete]: isComplete || lastItem
                  })}
                >
                  {label}
                </span>
              </li>
            );
          })}
        </ul>
      </aside>
    );
  })
);

StepsSidebar.propTypes = {
  location: PropTypes.object
};

export { StepsSidebar };
